
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      loading: false
    };
  }, // data
  computed: {
    ...mapState('comparison', ['districts']),
    ...mapGetters('filter', [
      'getStoreCodesList',
      'getDaysOfWeekList',
      'getStartingPeriod',
      'getEndingPeriod',
      'getStartingCompared',
      'getEndingCompared',
      'getCustomCalenderState'
    ])
  }, // computed
  async created() {
    try {
      this.loading = true;

      await this.fetchDistricts({
        startDate: this.getStartingPeriod,
        endDate: this.getEndingPeriod,
        storeCodes: this.getStoreCodesList,
        compareStartDate: this.getStartingCompared,
        compareEndDate: this.getEndingCompared,
        daysOfWeek: this.getDaysOfWeekList,
        useCustomCalender: this.getCustomCalenderState
      });
    } catch (error) {
      this.$q.notify({
        type: 'negative',
        position: 'top',
        message: `${error}`
      });
    } finally {
      this.loading = false;
    }
  }, // created
  methods: {
    ...mapActions('comparison', ['fetchDistricts'])
  } // methods
}; // export default
